module.exports = "/assets/b97592e577b274d3817bd48893d12a9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/CX.png
// module id = 2409
// module chunks = 0